import * as types from './chatroomActionTypes';
import { firebase } from './../../utils/firebase/firebase';

var sendMessageInProgress = function sendMessageInProgress() {
    return {
        type: types.SEND_MESSAGE
    };
};

var sendMessageInSuccess = function sendMessageInSuccess(payload) {
    //payload is only used by the action logger middleware
    return {
        type: types.SEND_MESSAGE_SUCCESS,
        payload: payload
    };
};

var sendMessageInError = function sendMessageInError(errorMessage) {
    return {
        type: types.SEND_MESSAGE_ERROR,
        errorMessage: errorMessage
    };
};

export var sendMessage = function sendMessage(chatroomId, message, type) {
    return function (dispatch, getState) {
        dispatch(sendMessageInProgress());
        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages').push({
            uid: firebase.firebaseApp.auth().currentUser.uid,
            message: message,
            type: type,
            createdAt: new Date().getTime()
        }).then(function () {
            var chatroomName = getState().chatroom.chatroomName;
            var metaData = getState().chatroom.metaData;
            //if the chatroomName end with ask the action to log is a question to journalist otherwise it's a comment
            var payload = { action: chatroomName.substr(-3) === 'ask' ? 'ask' : 'comment',
                entityId: chatroomName,
                entityValue: metaData,
                value: message,
                point: false
            };
            dispatch(sendMessageInSuccess(payload));
        }).catch(function (error) {
            dispatch(sendMessageInError(error.message));
        });
    };
};

export var selectMessage = function selectMessage(messageId, date) {
    return {
        type: types.SELECT_MESSAGE,
        messageId: messageId,
        date: date
    };
};

export var unselectMessage = function unselectMessage() {
    return {
        type: types.UNSELECT_MESSAGE
    };
};

var reportMessageInSuccess = function reportMessageInSuccess() {
    return {
        type: types.REPORT_MESSAGE_SUCCESS
    };
};

var reportMessageInError = function reportMessageInError(errorMessage) {
    return {
        type: types.REPORT_MESSAGE_ERROR,
        errorMessage: errorMessage
    };
};

export var reportMessage = function reportMessage(messageId) {
    return function (dispatch, getState) {
        var chatroomId = getState().chatroom.chatroomId;
        var messageKey = getState().chatroom.messages[messageId].key;
        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages/' + messageKey + '/report').push({
            uid: firebase.firebaseApp.auth().currentUser.uid,
            createdAt: new Date().getTime()
        }).then(function () {
            dispatch(reportMessageInSuccess());
        }).catch(function (error) {
            dispatch(reportMessageInError(error.message));
        });
    };
};

export var hideValidationPopup = function hideValidationPopup() {
    return {
        type: types.HIDE_VALIDATION_POPUP
    };
};

export var retrieveMessage = function retrieveMessage(key, uid, message, messageType, date, isReported, isInappropriate) {
    return {
        type: types.RETRIEVE_MESSAGE,
        key: key,
        uid: uid,
        message: message,
        messageType: messageType,
        date: date,
        isReported: isReported,
        isInappropriate: isInappropriate
    };
};

var updateMessageSuccess = function updateMessageSuccess(messages) {
    return {
        type: types.UPDATE_MESSAGE,
        messages: messages
    };
};

export var updateMessage = function updateMessage(key, isReported, isInappropriate) {
    return function (dispatch, getState) {
        var messages = getState().chatroom.messages;
        var message = messages.find(function (element) {
            return element.key === key;
        });
        var index = messages.indexOf(message);

        //create a new variable for immutability
        var newMessages = [].concat(messages);
        newMessages[index].isReported = isReported;
        newMessages[index].isInappropriate = isInappropriate;

        dispatch(updateMessageSuccess(newMessages));
    };
};

var addUserToChatInError = function addUserToChatInError(errorMessage) {
    return {
        type: types.ADDUSER_ERROR,
        errorMessage: errorMessage
    };
};

export var addUserToChat = function addUserToChat(chatroomId, uid) {
    return function (dispatch) {
        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/users').push(uid).catch(function (error) {
            dispatch(addUserToChatInError(error.message));
        });
    };
};

var retrieveUserInSuccess = function retrieveUserInSuccess(userId, username, avatar, isAdmin) {
    return {
        type: types.RETRIEVE_USER_SUCCESS,
        userId: userId,
        username: username,
        avatar: avatar,
        isAdmin: isAdmin
    };
};

var retrieveUserInError = function retrieveUserInError(errorMessage) {
    return {
        type: types.RETRIEVE_USER_ERROR,
        errorMessage: errorMessage
    };
};

export var retrieveUser = function retrieveUser(uid) {
    return function (dispatch) {
        firebase.firebaseApp.database().ref('/users/' + uid + '/publicData').once('value').then(function (snapshot) {
            var username = snapshot.val() && snapshot.val().displayName || '';
            var avatar = snapshot.val() && snapshot.val().avatar || '0';
            var isAdmin = snapshot.val() && snapshot.val().isAdmin || false;

            dispatch(retrieveUserInSuccess(uid, username, avatar, isAdmin));
        }).catch(function (error) {
            dispatch(retrieveUserInError(error.message));
        });
    };
};

export var sendPreview = function sendPreview(file) {
    return {
        type: types.SEND_PREVIEW,
        file: file
    };
};

export var cancelPreview = function cancelPreview() {
    return {
        type: types.CANCEL_PREVIEW
    };
};

export var startUpload = function startUpload() {
    return {
        type: types.START_UPLOAD
    };
};

export var cleanMessages = function cleanMessages() {
    return {
        type: types.CLEAN_MESSAGES
    };
};

export var leaveRoom = function leaveRoom() {
    return {
        type: types.LEAVE_CHATROOM
    };
};

export var getChatroomMetaData = function getChatroomMetaData(metaData) {
    return {
        type: types.GET_CHATROOM_METADATA,
        metaData: metaData
    };
};

export var showNotEnabledPopup = function showNotEnabledPopup() {
    return {
        type: types.SHOW_NOT_ENABLED_POPUP
    };
};

export var hideNotEnabledPopup = function hideNotEnabledPopup() {
    return {
        type: types.HIDE_NOT_ENABLED_POPUP
    };
};

var error = function error(errorMessage) {
    return {
        type: types.ERROR,
        errorMessage: errorMessage
    };
};

export var markMessageAsInappropriate = function markMessageAsInappropriate(messageId) {
    return function (dispatch, getState) {
        var chatroomId = getState().chatroom.chatroomId;
        var messageKey = getState().chatroom.messages[messageId].key;
        var update = {};
        update['/isInappropriate'] = true;
        update['/report'] = null;

        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages/' + messageKey).update(update).then(function () {
            dispatch(updateMessage(messageKey, true, true));
        }).catch(function (error) {
            dispatch(error(error.message));
        });
    };
};
export var closeReportOnMessage = function closeReportOnMessage(messageId) {
    return function (dispatch, getState) {
        var chatroomId = getState().chatroom.chatroomId;
        var messageKey = getState().chatroom.messages[messageId].key;
        var update = {};
        update['/report'] = null;
        update['/isInappropriate'] = false;

        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/messages/' + messageKey).update(update).then(function () {
            dispatch(updateMessage(messageKey, false, false));
        }).catch(function (error) {
            dispatch(error(error.message));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/chatroomActions.js
// module id = 12
// module chunks = 0